// extracted by css-extract-rspack-plugin
export default {"cls1":"ClaimDetails-cls1_BCT","cls2":"ClaimDetails-cls2_GQY ClaimDetails-cls1_BCT"};